<app-header></app-header>
<main role="main" class="container">
  <div>
    <router-outlet></router-outlet>
    <spinner [visible]="spinnerVisibility"></spinner>
    <toast></toast>
  </div>
</main>
<app-footer></app-footer>
